import List from 'modules/Services/Access/List/List'
import Sagas from 'modules/Services/Access/saga'
import Reducer from 'modules/Services/Access/reducer'

export default List

export { Sagas, Reducer }
